<template>
  <div class="page-break-container">
    <div :class="['page-break-buttons', `align-${align || 'center'}`]">
      <button 
        v-if="showPreviousButton"
        class="page-break-btn prev-btn"
        :class="{ 'disabled': isFirstPage }"
        :disabled="isFirstPage"
        type="button"
        @click="handlePreviousClick"
      >
        <svg class="btn-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>{{ previousButtonText || 'Geri' }}</span>
      </button>
      
      <button 
        v-if="showNextButton"
        class="page-break-btn next-btn"
        :class="{ 'disabled': isLastPage }"
        :disabled="isLastPage"
        type="button"
        @click="handleNextClick"
      >
        <span>{{ nextButtonText || 'Devam' }}</span>
        <svg class="btn-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageBreak',
  props: {
    align: {
      type: String,
      default: 'center'
    },
    nextButtonText: {
      type: String,
      default: 'Devam'
    },
    previousButtonText: {
      type: String,
      default: 'Geri'
    },
    showPreviousButton: {
      type: Boolean,
      default: true
    },
    showNextButton: {
      type: Boolean,
      default: true
    },
    isFirstPage: {
      type: Boolean,
      default: false
    },
    isLastPage: {
      type: Boolean,
      default: false
    },
    currentPage: {
      type: Number,
      default: 1
    },
    totalPages: {
      type: Number,
      default: 1
    }
  },
  methods: {
    handlePreviousClick() {
      if (!this.isFirstPage) {
        console.log('🔴 PageBreak: Previous button clicked, going to previous page');
        this.$emit('previous-page');
      }
    },
    handleNextClick() {
      if (!this.isLastPage) {
        console.log('🔴 PageBreak: Next button clicked, going to next page');
        this.$emit('next-page');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-break-container {
  margin: 20px 0;
  padding: 15px 0;
}

.page-break-buttons {
  display: flex;
  gap: 12px;

  &.align-left {
    justify-content: flex-start;
  }

  &.align-center {
    justify-content: center;
  }

  &.align-right {
    justify-content: flex-end;
  }
}

.page-break-btn {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 500;
  background: transparent;
  border: 2px solid #2c3e50;
  border-radius: 8px;
  cursor: pointer;
  outline: none;
  transition: all 0.3s ease;
  min-width: 100px;

  &:hover:not(.disabled) {
    background: rgba(44, 62, 80, 0.05);
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(44, 62, 80, 0.15);
    
    .btn-icon {
      transform: scale(1.1);
    }
  }

  &:active:not(.disabled) {
    transform: translateY(0);
    box-shadow: 0 1px 4px rgba(44, 62, 80, 0.1);
  }

  .btn-icon {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    transition: all 0.3s ease;
  }

  span {
    font-family: var(--font-family);
    font-size: 14px;
    letter-spacing: 0.2px;
    transition: all 0.3s ease;
  }

  // Geri butonu - gri border
  &.prev-btn {
    border-color: #6b7280;
    color: #6b7280;

    &:hover:not(.disabled) {
      background: rgba(107, 114, 128, 0.05);
      border-color: #4b5563;
      color: #4b5563;
    }
  }

  // Devam butonu - mavi border
  &.next-btn {
    border-color: #2c3e50;
    color: #2c3e50;

    &:hover:not(.disabled) {
      background: rgba(44, 62, 80, 0.05);
      border-color: #1a252f;
      color: #1a252f;
    }
  }

  // Disabled state
  &.disabled {
    opacity: 0.4;
    cursor: not-allowed;
    border-color: #d1d5db;
    color: #9ca3af;

    .btn-icon {
      opacity: 0.5;
    }
  }
}

// Tablet boyutu için
@media (max-width: 768px) {
  .page-break-btn {
    padding: 10px 18px;
    font-size: 14px;
    min-width: 110px;
    border-radius: 9px;
    
    .btn-icon {
      width: 15px;
      height: 15px;
    }
  }
}

// Küçük ekranlar için
@media (max-width: 480px) {
  .page-break-buttons {
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }

  .page-break-btn {
    width: 100%;
    max-width: 160px;
    padding: 10px 16px;
    font-size: 13px;
    min-width: 100px;
    border-radius: 8px;
    
    .btn-icon {
      width: 14px;
      height: 14px;
    }
  }
}

// Erişilebilirlik için motion reduction
@media (prefers-reduced-motion: reduce) {
  .page-break-btn {
    transition: none;
    
    .btn-icon,
    span {
      transition: none;
    }

    &:hover {
      transform: none;
      
      .btn-icon {
        transform: none;
      }
    }
    
    &:active {
      transform: none;
    }
  }
}
</style>
